import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  routes: [
    {path:'/', component: () => import('../views/Home.vue'),},
    {path:'/introduce', component: () => import('../views/Introduce.vue'),},
    {path:'/contact', component: () => import('../views/Contact.vue'),},
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js